import React from 'react';

import PropTypes from 'prop-types';

import { getLangCountryPrefix } from 'helpers/utils';

import clsx from 'clsx';

import styles from './Footer.module.css';
import { BUSINESS_HELP, BUSINESS_HELP_PAYSEND, HELP } from '../../../constants/UrlConstants';
import { PromoText } from '../common/promo-text/PromoText';

const FooterNav = (props) => {
    const navClass = clsx(styles.footerNavigation, {
        [styles.footerNavigationBlack]: props.promoDarkPage,
    });

    const getHref = (url, linkToNav) => {
        if (url === HELP || url === `${getLangCountryPrefix(props.lang, props.country)}${HELP}`) {
            return `${getLangCountryPrefix(props.lang, props.country)}${HELP}`;
        } else if (url === BUSINESS_HELP || url === `${getLangCountryPrefix(props.lang, props.country)}${BUSINESS_HELP}`) {
            return BUSINESS_HELP_PAYSEND;
        }
        return linkToNav;
    };

    const getLinks = (linksArray, lang, country, isLanding) => {
        return linksArray.map((link) => {
            const { name, url, isBlank, id } = link;
            const regexRes = /^\/resources/g;
            const isLinkHaveRegexRes = url.search(regexRes);
            const regexTerm = /^(\/(ga|grow)\/term)|(\/\/cloud.paysend.com)/g;
            const isLinkHaveRegexTerm = url.search(regexTerm);
            const hrefLink = !isLinkHaveRegexRes || !isLinkHaveRegexTerm ? url : `${getLangCountryPrefix(lang, country)}${url}`;
            const dataTestAttr = `footer-nav-link-${url.replace(/\//g, '')}`;
            return (
                <li key={`${id}${url.replace(/\s/g, '')}`}>
                    {isLanding ? (
                        <a data-testid={dataTestAttr} href={getHref(url, `${getLangCountryPrefix(lang, country)}${url}`)}>
                            {name}
                        </a>
                    ) : (
                        <a href={getHref(url, hrefLink)} target={isBlank ? '_blank' : '_self'}>
                            {name}
                        </a>
                    )}
                </li>
            );
        });
    };

    return (
        <PromoText tag="div" color={props.promoDarkPage ? 'gray40' : 'gray80'}>
            <nav className={navClass}>
                <ul>{props.links && Array.isArray(props.links) ? getLinks(props.links, props.lang, props.country, props.isLanding) : <></>}</ul>
            </nav>
        </PromoText>
    );
};

FooterNav.propTypes = {
    lang: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            isBlank: PropTypes.bool,
        }),
    ),

    isLanding: PropTypes.bool,
};

export default FooterNav;
